import { useEffect, useState } from "react";

const MOBILE_MAX_WIDTH = 768;

export function useIsMobile(maxWidth: number = MOBILE_MAX_WIDTH): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(`(max-width: ${maxWidth}px)`).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined") return;
    const mql = window.matchMedia(`(max-width: ${maxWidth}px)`);
    const listener = (e: MediaQueryListEvent) => setIsMobile(e.matches);

    // Safari < 14 uses addListener; guard both paths.
    if (typeof mql.addEventListener === "function") {
      mql.addEventListener("change", listener);
      return () => mql.removeEventListener("change", listener);
    }
    mql.addListener(listener);
    return () => mql.removeListener(listener);
  }, [maxWidth]);

  return isMobile;
}
